import { DataPhTags } from '@/analytics/tagging';
import { Button } from '@chakra-ui/react';
import NextLink from 'next/link';

export const ViewPurchaseButton: React.FC<{
  eventId: string;
  useLearningRegistrationCopy?: boolean;
}> = ({ eventId, useLearningRegistrationCopy = false }) => {
  return (
    <NextLink href={`/events/${eventId}/registrations`}>
      <Button
        variant="outline"
        colorScheme="gray"
        width={{ base: '100%', md: 'auto' }}
        data-ph-capture-attribute-event_name={DataPhTags.REGISTRATION_VIEW}
      >
        {useLearningRegistrationCopy ? 'View Enrollments' : 'View Registrations'}
      </Button>
    </NextLink>
  );
};
